import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  title: {
    fontWeight: idsTokens.typography.font.weight.bold,
  },
});
